import React from 'react';
import './Policy.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="page-container">
      <h2>Privacy Policy</h2>

      <p>
        <strong>1. Summary</strong><br />
        <br />
        <strong>1.1.</strong> Your privacy is important to us. It is Camplocation’s policy to respect
        your privacy regarding any information we may collect from you across our website,
        <a href="http://camplocation.com" target="_blank" rel="noopener noreferrer">camplocation.com</a> and the Camplocation app.
        <br />
        <strong>1.2.</strong> We use Your Personal data to provide and improve the Service.
        By using the Service, You agree to the collection and use of information in accordance with
        this Privacy Policy.
        <br />
        <strong>1.3.</strong> We only ask for personal information when we truly need it to provide
        a service to you. We collect it by fair and lawful means, with your knowledge and consent.
        <br />
        <strong>1.4.</strong> We don’t share any personally identifying information publicly or with
        third-parties, except when required to by law.
        <br />
        <strong>1.5.</strong> We only retain collected information for as long as necessary to provide
        you with your requested service. What data we store, we’ll protect within commercially acceptable
        means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or
        modification.
        <br />
        <strong>1.6.</strong> You are free to refuse our request for your personal information,
        with the understanding that we may be unable to provide you with our services.
        <br />
        <strong>1.7.</strong> Your continued use of our website and app will be regarded as acceptance
        of our practices around privacy and personal information. If you have any questions about how
        we handle user data and personal information, feel free to contact us at <a href="mailto:info@camplocation.com">info@camplocation.com</a>.
      </p>

      <p>
        <strong>2. Types of data collected</strong><br />
        <br />
        <em>Personal data</em><br />
        While using Our Service, We may ask You to provide Us with certain personally identifiable
        information that can be used to contact or identify You. Personally identifiable information
        may include, but is not limited to:
        <br />
        <strong>2.1.</strong> First name and last name
        <br />
        <strong>2.2.</strong> E-mail address
        <br />
        <strong>2.3.</strong> Bank account information in order to pay for products and/or services
        within the Service.
        <br />
        <strong>2.4.</strong> Usage data
        <br />
        <br />
        <em>Usage data</em><br />
        <strong>2.5.</strong> Usage Data is collected automatically when using the Service.
        <br />
        <strong>2.6.</strong> Usage Data may include information such as the pages of our Service that
        You visit, the time and date of Your visit, the time spent on those pages and other diagnostic data.
        <br />
        <strong>2.7.</strong> When You access the service by or through a mobile device, We may collect
        certain information automatically, including, but not limited to, the type of mobile device You use,
        the IP address of Your mobile device, Your mobile operating system and other diagnostic data.
        <br />
        <br />
        <em>Cookies</em><br />
        <strong>2.8.</strong> Cookies are files with a small amount of data that are commonly used as
        anonymous unique identifiers. These are sent to your browser from the website that you visit
        and are stored on your device's internal memory.
      </p>

      <p>
        <strong>3. Use of your personal data</strong><br />
        <br />
        <strong>3.1.</strong> The Company may use Personal Data for the following purposes:
        <br />
        <strong>3.1.1.</strong> To maintain and provide our service including the monitor of the usage
        of our services.
        <br />
        <strong>3.1.2.</strong> To manage Your registration as a user of the Service.
        <br />
        <strong>3.1.3.</strong> To contact You by e-mail or other equivalent forms of electronic
        communication, such as a mobile application's push notifications regarding updates or
        informative communications related to the functionalities, products or contracted services,
        including the security updates, when necessary or reasonable for their implementation.
        <br />
        <strong>3.1.4.</strong> With news, special offers and general information about other goods,
        services which we offer that are similar to those that you have already purchased or enquired about.
        <br />
        <strong>3.1.5.</strong> The development, compliance and undertaking of the purchase contract
        for the products, items or services You have purchased or of any other contract with Us
        through the Service.
        <br />
        <strong>3.1.6.</strong> To attend and manage Your requests to Us.
        <br />
        <strong>3.1.7.</strong> We may use Your information for other purposes, such as data analysis,
        identifying usage trends, determining the effectiveness of our promotional campaigns and to
        evaluate and improve our Service, products, services, marketing and your experience.
        <br />
        <strong>3.1.8.</strong> From time to time, we will communicate about functionality, changes or
        news in the service and product or other information that is assumed to be relevant to the
        individual user of our service.
      </p>

      <p>
        <strong>4. Retention time</strong><br />
        <br />
        <strong>4.1.</strong> Unless specified otherwise in this document, Personal Data shall be
        processed and stored for as long as required by the purpose they have been collected for
        and may be retained for longer due to applicable legal obligation or based on the Users’ consent.
        <br />
        <strong>4.2.</strong> Camplocation deletes the personal data as soon as storage is no longer
        considered necessary for the purpose for which it was collected, and when it is also not
        necessary to store in accordance with law. The general right of access to Camplocation's
        processing of personal data is fulfilled through this privacy statement.
        <br />
        <strong>4.3.</strong> If you have questions or requirements related to the processing of
        personal data, you can contact us at <a href="mailto:info@camplocation.com">info@camplocation.com</a>.
      </p>

      <p>
        <strong>5. How to delete your account?</strong><br />
        <br />
        <strong>5.1.</strong> You may delete your account and associated personal information at
        any time by contacting us at <a href="mailto:info@camplocation.com">info@camplocation.com</a>.
      </p>

      <p>
        <strong>6. What will be deleted?</strong><br />
        <br />
        <strong>6.1.</strong> All your personal information, including your user ID, first name
        and last name, e-mail address and saved favourite locations will be permanently deleted.
      </p>

      <p>
        <strong>7. Personal information to third parties</strong><br />
        <br />
        <strong>7.1.</strong> Camplocation does not sell personal information to third parties.
        We will only give third parties access to your personal information if it is necessary
        to be able to manage your customer relationship, for example to be able to deliver you
        personalized content with us or other websites. Access to your personal information for
        third parties may also be granted if you have consented to this.
        <br />
        <strong>7.2.</strong> Personal information and information about orders may also be disclosed
        to the police or other public authorities if necessary to comply with legal or regulatory
        obligations or requests.
      </p>

      <p>
        <strong>8. Location based interactions</strong><br />
        <br />
        <strong>8.1.</strong> This Application may collect, use, and share User location Data in order
        to provide location-based services.
        <br />
        <strong>8.2.</strong> Most browsers and devices provide tools to opt out from this feature by default.
        If explicit authorization has been provided, the User’s location data may be tracked by this Application.
        <br />
        <strong>8.3.</strong> The geographic location of the User is determined in a manner that isn't
        continuous, either at the specific request of the User or when the User doesn't point out its
        current location in the appropriate field and allows the application to detect the position
        automatically.
      </p>

      <p>
        <strong>9. Business transactions</strong><br />
        <br />
        <strong>9.1.</strong> If the Company is involved in a merger, acquisition or asset sale, Your Personal
        Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes
        subject to a different Privacy Policy.
      </p>

      <p>
        <strong>10. Other legal requirements</strong><br />
        <br />
        <strong>10.1.</strong> The Company may disclose Your Personal Data in the good faith belief that such
        action is necessary to:
        <br />
        <strong>10.1.1.</strong> Protect and defend the rights or property of the Company.
        <br />
        <strong>10.1.2.</strong> Prevent or investigate possible wrongdoing in connection with the Service.
        <br />
        <strong>10.1.3.</strong> Comply with a legal obligation.
        <br />
        <strong>10.1.4.</strong> Prevent or investigate possible wrongdoing in connection with the Service.
        <br />
        <strong>10.1.5.</strong> Protect against legal liability.
        <br />
        <strong>10.1.6.</strong> Protect the personal safety of Users of the Service or the public.
      </p>

      <p>
        <strong>11. Security of your personal data</strong><br />
        <br />
        <strong>11.1.</strong> The security of Your Personal Data is important to Us, but remember that no method
        of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use
        commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
      </p>

      <p>
        <strong>12. Analytics</strong><br />
        <br />
        <strong>12.1.</strong> We may use third-party Service providers to monitor and analyse the use of our Service.
        <br />
        <strong>12.2. Google analytics</strong>
        <br />
        <strong>12.2.1.</strong> Google Analytics is a web analytics service offered by Google that tracks and
        reports website traffic. Google uses the data collected to track and monitor the use of our Service.
        This data is shared with other Google services. Google may use the collected data to contextualize and
        personalize the ads of its own advertising network.
        <br />
        <strong>12.2.2.</strong> You may opt-out of certain Google Analytics features through your mobile device
        settings or by following the instructions provided by Google in their Privacy Policy: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
        
        <br />
        <strong>12.2.3.</strong> For more information on the privacy practices of Google, please visit the Google
        Privacy &amp; Terms web page: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
        <br />
        <strong>12.3. Firebase</strong>
        <br />
        <strong>12.3.1.</strong> Firebase is an analytics service provided by Google Inc.
        <br />
        <strong>12.3.2.</strong> You may opt-out of certain Firebase features through your mobile device settings
        or by following the instructions provided by Google in their Privacy Policy: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
        
        <br />
        <strong>12.3.3.</strong> We also encourage you to review Google's policy for safeguarding your data: <a href="https://support.google.com/analytics/answer/6004245" target="_blank" rel="noopener noreferrer">https://support.google.com/analytics/answer/6004245</a>
      
        <br />
        <strong>12.3.4.</strong> For more information on what type of information Firebase collects,
        please visit the How Google uses data when you use our partners' sites or apps webpage: <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">https://policies.google.com/technologies/partner-sites</a>
       
        <br />
        <strong>12.4. App Store Connect (Apple Inc.)</strong>
        <br />
        <strong>12.4.1.</strong> This Application is distributed on Apple's App Store, a platform for
        the distribution of mobile apps, provided by Apple Inc.
        <br />
        <strong>12.4.2.</strong> App Store Connect enables the Owner to manage this Application on Apple's App Store.
        Depending on the configuration, App Store Connect provides the Owner with analytics data on user engagement
        and app discovery, marketing campaigns, sales, in-app purchases, and payments to measure the performance of
        this Application. App Store Connect only collects such data from Users who have agreed to share them with
        the Owner. Users may find more information on how to opt out via their device settings by checking this link: <a href="https://support.apple.com/en-gb/108971" target="_blank" rel="noopener noreferrer">https://support.apple.com/en-gb/108971</a>
        
        <br />
        <strong>12.4.3.</strong> Place of processing: United States, please check this link: <a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noopener noreferrer">https://www.apple.com/legal/privacy/</a>
        
      </p>

      <p>
        <strong>13. Advertising</strong><br />
        <br />
        <strong>13.1.</strong> We may use Service Providers to show advertisements to You to help
        support and maintain Our Service.
        <br />
        <strong>13.2. Google adsense and Doubleclick cookie</strong>
        <br />
        <strong>13.2.1.</strong> Google, as a third party vendor, uses cookies to serve ads on our Service.
        Google's use of the DoubleClick cookie enables it and its partners to serve ads to our users based on
        their visit to our Service or other websites on the Internet.
        <br />
        <strong>13.3. Admob by Google</strong>
        <br />
        <strong>13.3.1.</strong> AdMob by Google is provided by Google Inc.
        <br />
        <strong>13.3.2.</strong> For more information on how Google uses the collected information, please visit
        the "How Google uses data when you use our partners' sites or app" page: <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">https://policies.google.com/technologies/partner-sites </a> 
         or visit the Privacy Policy of Google: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
        
      </p>

      <p>
        <strong>14. Payments</strong><br />
        <br />
        <strong>14.1.</strong> We may provide paid products and/or services within the Service. In that case,
        we may use third-party services for payment processing (e.g. payment processors).
        <br />
        <strong>14.2.</strong> We will not store or collect Your payment card details. That information is provided
        directly to Our third-party payment processors whose use of Your personal information is governed by their
        Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI
        Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and
        Discover. PCI-DSS requirements help ensure the secure handling of payment information.
        <br />
        <strong>14.3. Apple store in-app payments.</strong>
        <br />
        <strong>14.3.1.</strong> Their Privacy Policy can be viewed at <a href="https://www.apple.com/legal/privacy/en-ww/" target="_blank" rel="noopener noreferrer">https://www.apple.com/legal/privacy/en-ww/</a>
        <br />
        <strong>14.4. Google play in-app payments.</strong>
        <br />
        <strong>14.4.1.</strong> Their Privacy Policy can be viewed at <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">https://www.google.com/policies/privacy/</a>.
      </p>

      <p>
        <strong>15. Changes to this Privacy Policy</strong><br />
        <br />
        <strong>15.1.</strong> We may update our Privacy Policy from time to time. You are advised to review
        this page periodically for any changes.
      </p>

      <p>
        <strong>16. Contact us</strong><br />
        <br />
        <strong>16.1.</strong> If you have any questions or suggestions about this Privacy Policy,
        you can contact us at <a href="mailto:info@camplocation.com">info@camplocation.com</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
